import HttpClientToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { BuscarListaAcuerdosParams, BuscarListaAcuerdosResponse, defaultBuscarListaAcuerdosResponse, defaultDetalleListaAcuerdosResponse, defaultGenerarDocumentoListaAcuerdos, defaultNuevaListaAcuerdos, GenerarDocumentoListaAcuerdosResponse, GenerarListaAcuerdosParams, NuevaListaAcuerdosResponse, DetalleListaAcuerdosResponse } from '../../interfaces/tribunal/ListaAcuerdosInterface';

export const NuevaListaAcuerdos = () => {

    return new Promise<NuevaListaAcuerdosResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ListaAcuerdos/NuevaListaAcuerdos', {}, token)
            .then( ({ data } : { data : NuevaListaAcuerdosResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultNuevaListaAcuerdos, message: error.message } );
            });

        }

    });

}

export const DetalleListaAcuerdos = ( id: string ) => {

    return new Promise<DetalleListaAcuerdosResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post(`/Api/ListaAcuerdos/DetalleListadoAcuerdos/${ id }`, {}, token)
            .then( ({ data } : { data : DetalleListaAcuerdosResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultDetalleListaAcuerdosResponse });
            });

        }

    });

}

export const GenerarListaAcuerdos = ( params: GenerarListaAcuerdosParams ) => {

    return new Promise<GenerarDocumentoListaAcuerdosResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ListaAcuerdos/GenerarListaAcuerdos', params, token)
            .then( ({ data } : { data : GenerarDocumentoListaAcuerdosResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultGenerarDocumentoListaAcuerdos, message: error.message } );
            });

        }

    });

}

export const FinalizarListaAcuerdos = ( id: string ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/ListaAcuerdos/FinalizarListaAcuerdos/${ id }`, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const BuscarListaAcuerdos = ( params: BuscarListaAcuerdosParams ) => {

    return new Promise<BuscarListaAcuerdosResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/ListaAcuerdos/BuscarListaAcuerdos', params, token)
            .then( ({ data } : { data : BuscarListaAcuerdosResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultBuscarListaAcuerdosResponse });
            });

        }

    });

}
